module.exports = __webpack_public_path__ + "static/media/graph_strategies.29f3b3bb.png";